
import _ from "underscore";
import templateUrl from 'emun.vendor/file-import/vendor-file-import.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from "servicestack/service-bus";
import csvParser from 'webutils/services/csv-json';
import modals from 'webmodals/modals';
import 'servicestack/file-import/file-imports.client.scss'
//import exceptionsPrompt from 'servicestack/file-import/file-import-exceptions'

class VendorFileImportController {
    constructor($rootScope) { 
        let $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
        $ctrl.bus.send("QueryVendorUploadFileTypes.json?OrderBy=Position").then(function(args) {
            $ctrl.fileTypes = args.data.results;
        });
    }
	$onInit() {
		const $ctrl = this;
		$ctrl.mode = "view";
        $ctrl.realm = "VendorUploads";
		$ctrl.active = 0;
	}
	setFileType(fileType) {
		const $ctrl = this;
		$ctrl.fileType = fileType;
		$ctrl.folder = $ctrl.vendorId + "/" + $ctrl.fileType.destinationFolder + "/";
		if ($ctrl.fileType.destinationFilename !== "SAME") 
			$ctrl.folder = $ctrl.folder + $ctrl.fileType.destinationFilename
	}
    upload($files) {
        const $ctrl = this;
        if ($files && $files.length) {
            let req = {
                request: {
                    realm: $ctrl.realm,
                    description: $ctrl.fileType.fileType,
                    refId: $ctrl.vendorId,
                    tags: {
                        Visibility: "Public",
                        Parent: $ctrl.vendorId,
                        FileType: $ctrl.fileType.fileType,
                        DestinationFilename: $ctrl.fileType.destinationFilename,
                        DestinationFolder: $ctrl.fileType.destinationFolder,
                    }
                },
                files: $files,
                urls: []
            };

            $ctrl.bus.upload("CreateMedia.json", req).then(function (response) {
                $ctrl.media = response.data.media[0];
                $ctrl.$broadcast("$documentUploaded");
				$ctrl.active = 0;
            });
        }
    };
}

let VendorFileImport = {
    bindings: {
		vendorId: '@'
    },
    controller: VendorFileImportController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default VendorFileImport